import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CardColumnSelectionBase } from 'src/app/classes/base-classes/card-column/card-column-selection-base';
import { InsurancePolicyForm } from 'src/app/classes/form-groups/insurance-policy-form';
import { InsurancePolicySiteForm } from 'src/app/classes/form-groups/insurance-policy-site-form';
import { ArraySelectOption } from 'src/app/interfaces/array-select-option';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';

import { CardColumnDisplayModalComponent } from '../card-column-modal/card-column-display-modal/card-column-display-modal.component';

@Component({
  selector: 'app-insurance-policy-sites-modal',
  templateUrl:
    '../card-column-modal/card-column-display-modal/card-column-display-modal.component.html',
  styleUrls: [
    '../card-column-modal/card-column-display-modal/card-column-display-modal.component.less',
    './insurance-policy-sites-modal.component.less'
  ],
  providers: [SharedDataService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsurancePolicySitesModalComponent
  extends CardColumnDisplayModalComponent
  implements OnInit
{
  constructor(
    private SiteService: SiteService,
    protected override activeModal: NgbActiveModal,
    protected override ToastService: ToastService,
    protected override ChangeDetectorRef: ChangeDetectorRef,
    protected override SharedDataService: SharedDataService
  ) {
    super(activeModal, ToastService, ChangeDetectorRef, SharedDataService);

    this.enableFiltering = true;
    this.title = 'Select Client Sites';
    this.showSelectAllButton = true;
  }

  @Input() CompanyId!: number;
  @Input() InsurancePolicyFormGroup!: InsurancePolicyForm;
  @Input() SelectedInsurancePolicySites!: FormArray<InsurancePolicySiteForm>;

  override ngOnInit() {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
        returnError: true
      });
    }

    if (!this.InsurancePolicyFormGroup) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Insurance Policy Form.',
        { returnError: true }
      );
    }

    const {
      controls: { InsurancePolicySites: InsurancePolicySiteFormArray }
    } = this.InsurancePolicyFormGroup;

    if (!InsurancePolicySiteFormArray) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Insurance Policy form is missing Insurance Policy Site Form array.',
        { returnError: true }
      );
    }

    this.SelectedInsurancePolicySites = InsurancePolicySiteFormArray;

    this.selectionModel = new CardColumnSelectionBase(
      'multiple',
      this.SelectedInsurancePolicySites,
      { preventDataClone: true }
    );

    this.SiteService.getSites({
      attributes: JSON.stringify(['id', 'legalName', 'dba']),
      StreetAddress: JSON.stringify({
        attributes: ['id', 'address1', 'address2', 'city', 'state', 'zip']
      }),
      CompanyId: this.CompanyId
    }).subscribe({
      next: (Sites) => {
        Sites.forEach((Site) => {
          const { id: SiteId, legalName } = Site;

          if (!legalName) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Site is missing name.',
              { returnError: true }
            );
          }

          const InsurancePolicySiteFormGroup = new InsurancePolicySiteForm();
          InsurancePolicySiteFormGroup.patchValue({ SiteId });

          this.cardCollection.push({
            bodyText: legalName,
            record: {
              value: InsurancePolicySiteFormGroup,
              comparator: (compareValue, selectedValue) =>
                compareValue.value.SiteId === selectedValue.value.SiteId
            } as ArraySelectOption<InsurancePolicySiteForm>
          });
        });

        super.ngOnInit();
      }
    });
  }
}
